import React from 'react';
import styled from 'styled-components';
import { Chip } from '@mui/material';
import theme from '../theme';

const ChipStyled = styled(Chip)`
  && {
    background-color: ${({ $selected }) => ($selected ? theme.colors.NEU_PRIMARY : theme.colors.NEU_50)};
    border: 1px solid ${({ $selected }) => theme.colors.NEU_100};
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

    &:hover {
      background-color: ${({ $selected }) => ($selected ? theme.colors.NEU_100 : theme.colors.NEU_100)};

      .MuiChip-label {
        color: ${theme.colors.NEU_PRIMARY};
      }

      .MuiChip-icon {
        color: ${theme.colors.NEU_PRIMARY};
      }
    }
  }

  &.Mui-disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }

  .MuiChip-icon {
    margin-left: ${(props) => (props.$iconOnly ? '0' : '5px')};
    margin-right: ${(props) => (props.$iconOnly ? '0' : '-6px')};
    color: ${({ $selected }) => ($selected ? theme.colors.NEU_0 : theme.colors.NEU_PRIMARY)};
  }

  .MuiChip-label {
    font-family: ${theme.fonts.TEXT_FONT}, sans-serif;
    color: ${({ $selected }) => ($selected ? theme.colors.NEU_0 : theme.colors.NEU_PRIMARY)};
    font-weight: 300;
    line-height: 18px;
    font-size: ${(props) => props.fontSize || theme.fontSizes.small};
  }
`;

const PillTag = ({ label, variant, fontSize, icon, selected, ...props }) => {
  const iconOnly = icon && !label;
  return <ChipStyled variant={variant || 'fill'} fontSize={fontSize} label={label} icon={icon} $iconOnly={iconOnly} $selected={selected} {...props} />;
};

export default PillTag;
